module.exports = __webpack_public_path__ + "static/media/zhoubaotisong.a27eeadf.png";